var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPromotionNextMonth = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 23,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.903 1.67A2 2 0 0 1 8.397 1h11.205a2 2 0 0 1 1.495.67l4.681 5.261a2 2 0 0 1-.043 2.707L15.45 20.472a2 2 0 0 1-2.902 0L2.266 9.638a2 2 0 0 1-.044-2.707z"
})));
export default SvgPromotionNextMonth;